export default "__VITE_ASSET__Cg2DdIf5__"